// extracted by mini-css-extract-plugin
export default {"item":"AggregatorItem_item__GgJAr"};